var _rect, _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPermitMarketplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 39,
    r: 27,
    fill: "#33D085"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 46.75C30.2986 46.75 31.25 45.7986 31.25 44.625C31.25 43.4514 30.2986 42.5 29.125 42.5C27.9514 42.5 27 43.4514 27 44.625C27 45.7986 27.9514 46.75 29.125 46.75Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 46.75C53.6736 46.75 54.625 45.7986 54.625 44.625C54.625 43.4514 53.6736 42.5 52.5 42.5C51.3264 42.5 50.375 43.4514 50.375 44.625C50.375 45.7986 51.3264 46.75 52.5 46.75Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 2.125H20.625L26.32 30.5788C26.5143 31.5571 27.0466 32.4359 27.8235 33.0614C28.6005 33.6869 29.5727 34.0191 30.57 34H51.225C52.2223 34.0191 53.1945 33.6869 53.9715 33.0614C54.7484 32.4359 55.2807 31.5571 55.475 30.5788L58.875 12.75H22.75",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 2.125H20.625L26.32 30.5788C26.5143 31.5571 27.0466 32.4359 27.8235 33.0614C28.6005 33.6869 29.5727 34.0191 30.57 34H51.225C52.2223 34.0191 53.1945 33.6869 53.9715 33.0614C54.7484 32.4359 55.2807 31.5571 55.475 30.5788L58.875 12.75H22.75",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPermitMarketplace);
export default __webpack_public_path__ + "static/media/ico_permit_marketplace.024ac36bfbf38a28d19932d6e97908a1.svg";
export { ForwardRef as ReactComponent };